import custAxios, { attachToken } from "../../services/axiosConfig";
import { errorMessage, successMessage } from "../../globalFunctions";
import { brandConstants } from "../constants/brandConstants";

export const storeBrands = (value) => async (dispatch) => {

    dispatch({ type: brandConstants.STORE_BRAND_REQUEST });
    try {
        attachToken();
        const res = await custAxios.post("/admin/brands/store", value);
        if (res?.data?.status == "success") {

            dispatch({
                type: brandConstants.STORE_BRAND_SUCCESS,
                payload: res?.data.data,
            });
            successMessage(JSON.stringify(res?.data?.message))
            return res?.data;

        } else if (res?.data?.status == "warning") {

            dispatch({
                type: brandConstants.STORE_BRAND_FAILURE,
            });
            errorMessage(JSON.stringify(res?.data?.message))
            return res?.data;
        }
    } catch (error) {
        dispatch({
            type: brandConstants.STORE_BRAND_FAILURE,
            payload: error?.response?.data?.message || "Server Error",
        });
        errorMessage(JSON.stringify(error.response.data.message));
    }
};

export const fetchBrands = () => async (dispatch) => {

    dispatch({ type: brandConstants.FETCH_BRAND_REQUEST });
    try {
        attachToken();
        const res = await custAxios.get("/admin/brands/list");

        if (res?.data?.status == "success") {
            dispatch({
                type: brandConstants.FETCH_BRAND_SUCCESS,
                payload: res?.data.data,
            });
            return "success";

        } else if (res?.data?.status == "warning") {

            dispatch({
                type: brandConstants.FETCH_BRAND_FAILURE,
                payload: res?.data?.message,
            });
            return "warning";
        }
    } catch (error) {
        dispatch({
            type: brandConstants.FETCH_BRAND_FAILURE,
            payload: error?.response?.data?.message || "Server Error",
        });
        errorMessage(error.response.data.message);
    }
};

